import sumFunction from './sum-function';
sumFunction.install = Vue => Vue.component(sumFunction.name, sumFunction);//注册组件
export default sumFunction;


// WEBPACK FOOTER //
// ./src/myplugin/sumFunction/index.js